try {
  console.log("[info] CyberCloud Setup process.env.PACK_TIME", process.env.PACK_TIME);
} catch {
  // ignore
}

import("./bootstrap");
